import { useEffect, useState } from 'react';

export const useCSVChartData = ({
  chartType, title, data, labels 
}) => {
  const [currentData, setCurrentData] = useState(data);
  const [currentLabels, setCurrentLabels] = useState(labels);
  const [csvData, setCsvData] = useState([[]]);

  useEffect(() => {
    if (
      ((!data || !labels) && chartType === 'simple')
      || ((!data.every(d => d?.data) || !labels) && chartType === 'multi')
      || (JSON.stringify(currentData) === JSON.stringify(data)
        && JSON.stringify(currentLabels) === JSON.stringify(labels))
    ) {
      return;
    }

    const csvArray = chartType === 'simple'
      ? [['Timestamp', `${title} Data`], ...data.map((datum, i) => [labels[i], datum])]
      : [
        ['Timestamp', `${data[0].label} Data`, `${data[1].label} Data`, `${data[2].label} Data`],
        ...data[0].data.map((datum, i) => [labels[i], datum, data[1].data[i], data[2].data[i]]),
      ];

    setCurrentData(data);
    setCurrentLabels(labels);
    setCsvData(csvArray);
  }, [data, labels, title, chartType, currentData, currentLabels]);
  
  return csvData;
}

export default useCSVChartData;
